import { render, staticRenderFns } from "./SearchUsers.vue?vue&type=template&id=2f8b390a&scoped=true&"
import script from "./SearchUsers.vue?vue&type=script&lang=js&"
export * from "./SearchUsers.vue?vue&type=script&lang=js&"
import style0 from "./SearchUsers.vue?vue&type=style&index=0&id=2f8b390a&lang=scss&scoped=true&"
import style1 from "./SearchUsers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b390a",
  null
  
)

export default component.exports